import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import HomePage from './pages/HomePage';
import AboutUs from './pages/AboutUs';
import Portfolio from './pages/Portfolio';
import BusinessBuilder from './pages/BusinessBuilder';
import Simplified from './pages/Simplified';
import WeWantYou from './pages/WeWantYou';
import InvestmentOpportunities from './pages/InvestmentOpportunities';
import Contact from './pages/Contact';
import AssessmentTool from './pages/AssessmentTool';
import AssessmentResults from './pages/AssessmentResults';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminCompanies from './pages/admin/AdminCompanies';
import AdminLeads from './pages/admin/AdminLeads';

function App() {
  return (
    <>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/portfolio" element={<Portfolio />} />
          <Route path="/business-builder" element={<BusinessBuilder />} />
          <Route path="/simplified" element={<Simplified />} />
          <Route path="/savings-calculator" element={<AssessmentTool />} />
          <Route path="/assessment" element={<AssessmentTool />} />
          <Route path="/assessment/results/:id" element={<AssessmentResults />} />
          <Route path="/we-want-you" element={<WeWantYou />} />
          <Route path="/investment-opportunities" element={<InvestmentOpportunities />} />
          <Route path="/automation-fund" element={<InvestmentOpportunities />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/companies" element={<AdminCompanies />} />
          <Route path="/admin/leads" element={<AdminLeads />} />
        </Routes>
      </Router>
      <Toaster />
    </>
  );
}

export default App;
